/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/button-has-type */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */

import './index.css';
import {
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { ebookBookTemplateActions } from '@orientaction/api-actions';
import {
  BarEdition,
  Editor,
  ItemChapter,
  ItemPage,
  Layout,
  SimpleModal,
} from '@orientaction/components';
import {
  EditorCitation,
  ModalEditingEbook,
  TextAreaQuestion,
  VideoImport,
} from '@orientaction/components/Admin';
import { deleteVideoByUrl, isYoutubeUrl, VideoImportValue } from '@orientaction/components/Admin/VideoImport';
import { ebookBookValues } from '@orientaction/reducers';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { ReactComponent as Add } from '../../../Asset/svg/add_white.svg';
import { ReactComponent as Broder } from '../../../Asset/svg/border_white.svg';
import { ReactComponent as Browser } from '../../../Asset/svg/browser.svg';
import { ReactComponent as Close } from '../../../Asset/svg/close.svg';
import { ReactComponent as Delete } from '../../../Asset/svg/delete.svg';
import { ReactComponent as Enc } from '../../../Asset/svg/enc.svg';
import { ReactComponent as Move } from '../../../Asset/svg/move.svg';
import { ReactComponent as RemoveB } from '../../../Asset/svg/removeB.svg';
import { ReactComponent as Save } from '../../../Asset/svg/save.svg';
import { ReactComponent as Linked } from '../../../Asset/svg/link.svg';
import type { EbookBookTemplateValues, EbookDetail } from '@orientaction/types';
import { apiServiceNative } from '../../../utils/fetchNative';
import Loader from '../../AdminGame/EditPage/loader-edit';
import ModalEditGame from '../../AdminGame/EditPage/modal-edit-game';
import style from '../style';
import ItemBlocks from './ItemBlock';
import OaLabel from '@orientaction/commons/OaLabel';
import MediaVideoPlayer from '@orientaction/components/MediaVideoPlayer';
import { cloneDeep } from 'lodash';

const EditEbookPage: React.FC = () => {
  const classes = style();
  const [showEdition, setShowEdition] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [templateBlocks, setTemplateBlocks] = useState<any>([]);
  const [allBlocks, setAllBlock] = useState<any>([]);
  const [indexSelected, setIndexSelected] = useState<any>(0);
  const [blockSelected, setBlockSelected] = useState<any>({});
  const [valueInput, setValueInput] = useState<any>();
  const [defaultValue, setAllDefaultValue] = useState<any>(allBlocks);
  const [pulseMove, setPulseMove] = useState<number>(-1);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [urlVideoText, setUrlVideoText] = useState<string>('');

  const { id } = useParams<{ id?: string }>();
  const valuesEbooksTemplate: EbookBookTemplateValues = useSelector(ebookBookValues);
  const dispatch = useDispatch();
  const history = useHistory();
  const [openExit, setOpenExit] = useState(false);
  const [open, setOpen] = useState(false);
  const [textLoading, setTextLoading] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const imgRef = useRef<any>(null);
  const [url, setUrl] = useState('');
  const [openEditImg, setOpenEditImg] = useState<boolean>(false);
  const [imageDimensions, setImageDimensions] = useState<any>({});
  const [indexEditImg, setIndexEditImg] = useState<any>(null);
  const containerRef = useRef<any>(null);
  const WINDOW_SIZE = 120;
  const WINDOW_MARGIN = 40;
  const [renderStart, setRenderStart] = useState<number>(0);
  const [isNavigating, setIsNavigating] = useState<boolean>(false);
  const [openDialogVideo, setOpenDialogVideo] = useState<boolean>(false);
  const [videoImportInitial, setVideoImportInitial] = useState<Partial<VideoImportValue>>({});
  const [isEditedVideo, setIsEditedVideo] = useState<boolean>(false);
  const [indexSelectedForVideo, setIndexSelectedForVideo] = useState<number>();
  const [dataImg, setDataImg] = useState<any>({
    imgLink: '',
    checkedLink: false,
  });
  const [pendingScrollIndex, setPendingScrollIndex] = useState<number | null>(null);
  const scrollLoadingRef = useRef<boolean>(false);
  const [loadingTop, setLoadingTop] = useState<boolean>(false);
  const [loadingBottom, setLoadingBottom] = useState<boolean>(false);
  const scrollObserverRef = useRef<MutationObserver | null>(null);
  // Tracks the current title visible in viewport for sidebar highlighting (updated on scroll)
  const [currentTitleIndex, setCurrentTitleIndex] = useState<number>(0);
  const isProgrammaticScrollRef = useRef<boolean>(false);
  const videosToDeleteRef = useRef<string[]>([]);

  const shouldDeleteFirebaseVideo = (videoUrl?: string | null): videoUrl is string =>
    !!videoUrl && !videoUrl.startsWith('blob:') && !isYoutubeUrl(videoUrl);

  const queueVideoDeletion = (videoUrl?: string | null) => {
    if (shouldDeleteFirebaseVideo(videoUrl)) {
      videosToDeleteRef.current.push(videoUrl);
    }
  };

  const deletePendingVideos = async () => {
    const pendingDeletions = [...videosToDeleteRef.current];
    videosToDeleteRef.current = [];
    if (pendingDeletions.length > 0) {
      await Promise.allSettled(pendingDeletions.map(videoUrl => deleteVideoByUrl(videoUrl)));
    }
  };

  const scrollToBottom = (blocksArray?: any[]) => {
    const blocks = blocksArray || allBlocks;
    const total = blocks?.length || 0;
    if (total === 0) return;

    const lastBlockIndex = total - 1;
    const windowStart = Math.max(0, lastBlockIndex - WINDOW_SIZE + 1);

    // Désactive onScroll pendant le scroll programmé
    isProgrammaticScrollRef.current = true;

    setIsNavigating(true);
    setIndexSelected(lastBlockIndex);
    setValueInput(lastBlockIndex + 1);
    if (blocks[lastBlockIndex]) setBlockSelected(blocks[lastBlockIndex]);

    setRenderStart(windowStart);
    setPendingScrollIndex(lastBlockIndex);
  };

  useEffect(() => {
    sessionStorage.setItem('book', 'true');
    const fetchData = async () => {
      try {
        // 1) Essaye de lire depuis le sessionStorage pour éviter un nouvel appel API
        const cached = sessionStorage.getItem('bloc-templates');
        if (cached) {
          try {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed)) {
              setTemplateBlocks(parsed);
              return;
            }
          } catch (e) {
            console.error('Error fetching data:', e);
          }
        }

        const dataTemplateApi = await apiServiceNative.get(
          '/api/bloc-templates?populate=*&sort=id:asc'
        );

        const templates = dataTemplateApi?.data || [];
        setTemplateBlocks(templates);

        // 2) Stocke le résultat dans le sessionStorage pour les prochains montages
        try {
          sessionStorage.setItem('bloc-templates', JSON.stringify(templates));
        } catch (e) {
          console.error('Error fetching data:', e);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedId = sessionStorage.getItem('id') || id;
        if (storedId && !sessionStorage.getItem('fromEdit')) {
          const response: EbookDetail = await apiServiceNative.get(`/api/ebook-details/${storedId}`);
          dispatch(ebookBookTemplateActions.setAllValues(response as any));
          setAllBlock(response?.content);
          sessionStorage.setItem('id', storedId);
        } else {
          setAllBlock(valuesEbooksTemplate?.content || []);
        }
        sessionStorage.removeItem('fromEdit');
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [dispatch, id]);

  useEffect(() => {
    const el = containerRef.current as HTMLElement | null;
    if (!el) return;

    let scrollTimeout: NodeJS.Timeout | null = null;
    let lastScrollTop = el.scrollTop;

    const onScroll = () => {
      const currentScrollTop = el.scrollTop;
      const scrollDelta = Math.abs(currentScrollTop - lastScrollTop);
      lastScrollTop = currentScrollTop;

      // Ignore les micro-scrolls (moins de 5px) qui peuvent être causés par scrollIntoView
      if (scrollDelta < 5 && isProgrammaticScrollRef.current) {
        return;
      }

      // Si un scroll programmé est en cours, on attend un peu avant de réagir
      // Cela permet de distinguer un scroll manuel d'un scroll programmé
      if (isProgrammaticScrollRef.current || isNavigating) {
        // Si le scroll continue après un délai, c'est probablement un scroll manuel
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(() => {
          // Après 150ms sans scroll programmé, on considère que c'est un scroll manuel
          if (!isProgrammaticScrollRef.current && !isNavigating) {
            handleScrollUpdate();
          }
        }, 150);
        return;
      }

      // Scroll manuel normal
      handleScrollUpdate();
    };

    const updateSidebarHighlight = () => {
      const containerTop = el.getBoundingClientRect().top;
      const containerHeight = el.clientHeight;
      const viewportCenter = containerTop + containerHeight / 2;

      let closestTitleIdx = currentTitleIndex;
      let closestDistance = Infinity;

      // Ne cherche que dans la fenêtre virtuelle actuelle pour optimiser les performances
      const startIdx = Math.max(0, renderStart);
      const endIdx = Math.min(renderStart + WINDOW_SIZE, allBlocks.length);

      for (let index = startIdx; index < endIdx; index++) {
        const block = allBlocks[index];
        if (block?.bloc_template === 2) {
          const titleElement = document.getElementById(`title-${index}`);
          if (titleElement) {
            const rect = titleElement.getBoundingClientRect();
            // Vérifie que l'élément est vraiment visible dans le viewport
            if (rect.height > 0 && rect.width > 0) {
              const titleCenter = rect.top + rect.height / 2;
              const distance = Math.abs(titleCenter - viewportCenter);

              // Trouve le titre le plus proche du centre du viewport
              if (distance < closestDistance && rect.top < viewportCenter) {
                closestDistance = distance;
                closestTitleIdx = index;
              }
            }
          }
        }
      }

      // Met à jour seulement si le titre a changé
      if (closestTitleIdx !== currentTitleIndex) {
        setCurrentTitleIndex(closestTitleIdx);
      }
    };

    const handleScrollUpdate = () => {
      // Ignore si un chargement de fenêtre virtuelle est en cours
      if (scrollLoadingRef.current) return;

      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200;
      const nearTop = el.scrollTop <= 200;
      const total = allBlocks?.length || 0;

      // Mise à jour du highlight de la sidebar
      updateSidebarHighlight();

      // Gestion du lazy loading (chargement de la fenêtre virtuelle)
      if (nearBottom && renderStart + WINDOW_SIZE < total) {
        scrollLoadingRef.current = true;
        setLoadingBottom(true);
        const next = Math.min(renderStart + 40, Math.max(0, total - WINDOW_SIZE));
        if (next !== renderStart) {
          setRenderStart(next);
          setTimeout(() => {
            scrollLoadingRef.current = false;
            setLoadingBottom(false);
          }, 300);
        } else {
          scrollLoadingRef.current = false;
          setLoadingBottom(false);
        }
      } else if (nearTop && renderStart > 0) {
        scrollLoadingRef.current = true;
        setLoadingTop(true);
        const next = Math.max(0, renderStart - 40);
        if (next !== renderStart) {
          setRenderStart(next);
          setTimeout(() => {
            scrollLoadingRef.current = false;
            setLoadingTop(false);
          }, 300);
        } else {
          scrollLoadingRef.current = false;
          setLoadingTop(false);
        }
      }
    };

    el.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      el.removeEventListener('scroll', onScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [renderStart, allBlocks, currentTitleIndex, isNavigating]);

  const handleChangeNumLines = (delta: number, index: number) => {
    const newBlocks = [...allBlocks];

    newBlocks[index].numLines = delta || 1;
    setAllBlock(newBlocks);
  };

  const renderLines = (numLines: number) => {
    return (
      <div className="lines-container">
        {[...Array(numLines)].map((_, index) => (
          <div key={index} className={`line ${index === numLines - 1 ? 'last-line' : ''}`} />
        ))}
      </div>
    );
  };
  const [styleEditor, setStyleEditor] = useState<any>();
  const [stateEdition, setStateEdition] = useState<any>();
  const [showLinkPopup, setShowLinkPopup] = useState<boolean>(false);
  const [position, setPosition] = useState<string>();

  const editStyleEditor = (styleCommand: any, arg: any) => {
    if (allBlocks[indexSelected]?.bloc_template === 1) {
      setAllBlock((prevData: any) => {
        const dataPrev = [...prevData];
        dataPrev[indexSelected].styleEditor = { styleCommand, arg };
        dispatch(ebookBookTemplateActions.updateField('content', dataPrev));
        return dataPrev;
      });
    }
  };

  const editPosition = (alignement: any) => {
    if (allBlocks[indexSelected]?.bloc_template === 1) {
      setAllBlock((prevData: any) => {
        const dataPrev = [...prevData];
        dataPrev[indexSelected].alignement = alignement;
        dispatch(ebookBookTemplateActions.updateField('content', dataPrev));
        return dataPrev;
      });
    }
  };

  const renderTypeParagraphe = (block: any, index: number) => {
    switch (block?.contentForType) {
      case 'normal':
        return (
          <div>
            <Editor
              isSmall={true}
              handleActiveStyles={(data: any) => {
                setStateEdition(data);
              }}
              handleFocused={(isFocused: boolean) => {
                setShowEdition(isFocused);
              }}
              styleEditor={block?.styleEditor}
              showLinkPopupE={!!block?.showLinkPopup}
              defaultValue={block?.paragraphe}
              key={index}
              isEbook={true}
              handleChange={content => handleChangeInput(content, index, 'paragraphe')}
              pulseMove={pulseMove}
              position={block?.alignement}
              handlePosition={pos => {
                setPosition(pos);
                handleChangeInput(pos, index, 'alignement');
              }}
              oneLine={true}
            />
          </div>
        );
      case 'citation':
        return (
          <EditorCitation
            key={index}
            defaultValue={block?.citation}
            defaultAutor={block?.author}
            handleChange={({ citation, autor }) => {
              handleChangeInput(citation, index, 'citation');
              handleChangeInput(autor, index, 'author');
            }}
            isEbook={true}
          />
        );
      case 'encyclopedia':
        return (
          <div className={classes.enclopedieContainer}>
            <Enc className={classes.iconEnc} />
            <div style={{ width: '100%' }}>
              <Editor
                isSmall={true}
                handleActiveStyles={(data: any) => {
                  setStateEdition(data);
                }}
                handleFocused={(isFocused: boolean) => {
                  setShowEdition(isFocused);
                }}
                styleEditor={block?.styleEditor}
                showLinkPopupE={!!block?.showLinkPopup}
                defaultValue={block?.encyclopedia}
                key={index}
                isEbook={true}
                handleChange={content => handleChangeInput(content, index, 'encyclopedia')}
                pulseMove={pulseMove}
                placeholder="Cliquer pour ajouter une information"
                position={block?.alignement}
                handlePosition={pos => {
                  setPosition(pos);
                  handleChangeInput(pos, index, 'alignement');
                }}
              />
            </div>
          </div>
        );
      default:
    }
  };

  const handleAddUpdate = async (isPublish?: boolean) => {
    const data = {
      ...valuesEbooksTemplate,
      content: allBlocks,
      publishedAt: isPublish ? new Date() : null,
    };

    localStorage.removeItem('idFILESTemps');
    !isPublish
      ? setTextLoading('Sauvegarde en cours...')
      : setTextLoading('Publication en cours...');

    setLoading(true);
    const ebookId = sessionStorage.getItem('id');

    if (ebookId) {
      try {
        const response = await apiServiceNative.put(`/api/update-serious-ebook/${ebookId}`, {
          data,
        });
        await deletePendingVideos();
        setLoading(false);
        dispatch(ebookBookTemplateActions.setAllValues(response));
        setAllBlock(response?.content);
      } catch (error) {
        setLoading(false);
        console.error('Update error:', error);
      }
    } else {
      try {
        const response = await apiServiceNative.post('/api/create-ebook', { data });
        await deletePendingVideos();
        dispatch(ebookBookTemplateActions.setAllValues(response));
        setAllBlock(response?.content);
        sessionStorage.setItem('id', response?.id);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Create error:', error);
      }
    }
  };

  const renderTypeBlock = (block: any, index: number) => {
    switch (block?.bloc_template) {
      case 1:
        return renderTypeParagraphe(block, index);
      case 2:
        return (
          <input
            id={`title-${index}`}
            className={classes.editArea}
            style={{
              height: 30,
              fontWeight: block?.title_type === 'subtitle' ? 600 : 700,
              fontSize: block?.title_type === 'subtitle' ? 14 : 16,
            }}
            type="text"
            placeholder="Cliquer pour ajouter un titre"
            value={block.title}
            onInput={(e: any) => handleChangeInput(e.target.value, index, 'title')}
          />
        );

      case 3:
        return (
          <>
            <div className="qcm-block">
              <TextAreaQuestion
                placeholder="Cliquer pour rédiger une question"
                minHeight={21}
                defaultValue={allBlocks[index]?.qcm_title}
                handleChange={(value: any) => {
                  handleChangeInput(value, index, 'qcm_title');
                }}
              />
              {allBlocks[index]?.qcm?.[0]?.response?.map((response: any, responseIndex: number) => (
                <div key={response.id} className="option" style={{ paddingTop: 5 }}>
                  {response.isOther ? (
                    <div style={{ width: '100%' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input type="radio" style={{ margin: '0px 5px 0px 0px' }} disabled={true} />
                        <span className="option-title" style={{ paddingLeft: 5 }}>
                          Autre
                        </span>
                      </div>
                      <textarea
                        style={{ outline: 'none', border: 'none', borderRadius: 0, fontSize: 13 }}
                        className={classes.editArea}
                        placeholder="Champ texte réservé aux bénéficiaires"
                        value={response.responseText}
                        readOnly={true}
                      />
                    </div>
                  ) : (
                    <>
                      <input type="radio" style={{ margin: '0px 5px 0px 0px' }} disabled={true} />
                      <TextAreaQuestion
                        placeholder="Entrer une réponse"
                        minHeight={21}
                        defaultValue={response.responseText}
                        handleChange={(value: any) => {
                          handleChangeOption(index, responseIndex, value);
                        }}
                        isRadio={true}
                      />
                      {/* <input
                        type="text"
                        placeholder="Entrer une réponse"
                        value={response.responseText}
                        onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChangeOption(index, responseIndex, e.target.value)
                        }
                        className="normal-input"
                      /> */}
                    </>
                  )}
                  <IconButton
                    aria-label="delete"
                    className="delete-button"
                    style={{ background: 'transparent' }}
                    onClick={() => handleDeleteOption(index, responseIndex)}>
                    <RemoveB style={{ width: 15, height: 15 }} />
                  </IconButton>
                </div>
              ))}
              <div className="btnBlockBtn">
                <button className="button add-option" onClick={() => handleAddOption(index)}>
                  Ajouter une option
                </button>
                <button
                  className="button add-option btn-autre"
                  onClick={() => handleAddOption(index, true)}>
                  Ajouter "Autre"
                </button>
              </div>
            </div>
          </>
        );

      case 4:
        return (
          <>
            <div className="text-area-block">
              <TextAreaQuestion
                placeholder="Cliquer pour rédiger une question"
                minHeight={21}
                defaultValue={allBlocks[index]?.free_question_title}
                handleChange={(value: any) => {
                  handleChangeInput(value, index, 'free_question_title');
                }}
              />
              {/* <input
                className="editArea"
                type="text"
                placeholder="Cliquer pour rédiger une question"
                value={allBlocks[index]?.free_question_title}
                onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeInput(e.target.value, index, 'free_question_title')
                }
              /> */}
              <label className="line-control">
                Nombre de lignes disponibles pour la réponse:
                <input
                  type="number"
                  value={allBlocks[index].numLines}
                  min={1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeNumLines(parseInt(e.target.value, 10), index)
                  }
                  className="num-lines-input"
                />
              </label>
              {renderLines(allBlocks[index].numLines)}
            </div>
          </>
        );
      case 5:
        return (
          <div
            style={{
              position: 'relative',
              padding: 5,
              minHeight: 450,
            }}>
            <img
              src={block?.img?.url}
              alt=""
              loading="lazy"
              style={{ width: '100%', display: 'block' }}
              draggable={false}
            />
            <div className={classes.iconBtnImage} key={url}>
              <IconButton
                aria-label="delete"
                style={{ background: '#E63C3C' }}
                onClick={() => {
                  const updatedItems = [...allBlocks];
                  updatedItems.splice(index, 1);
                  setAllBlock(updatedItems);
                }}>
                <Close className={classes.icon} />
              </IconButton>
              <IconButton
                aria-label="delete"
                style={{ background: '#000A8C', marginTop: 15 }}
                onClick={() => {
                  const img = new Image();
                  img.src = block?.img?.url;
                  img.onload = () => {
                    setImageDimensions({
                      height: img.height,
                      width: img.width,
                    });
                  };
                  img.onerror = () => {
                    console.error('Failed to load image');
                  };
                  setUrl(block?.img?.url);
                  setDataImg({
                    imgLink: block.imgLink,
                    checkedLink: block.checkedLink,
                  });
                  setOpenEditImg(true);
                  setIndexEditImg(index);
                }}>
                <Broder className={classes.icon} />
              </IconButton>
              {block.checkedLink && (
                <IconButton
                  aria-label="delete"
                  disableRipple={true}
                  disableFocusRipple={true}
                  style={{
                    background: 'white',
                    marginTop: 15,
                    border: '1px solid #000A8C',
                    cursor: 'auto',
                  }}>
                  <Linked className={classes.icon} />
                </IconButton>
              )}
            </div>
          </div>
        );
      case 6:
        return (
          <div className={classes.containerSommaire}>
            <div className={classes.titleSommaire} style={{ fontWeight: 700, fontSize: 18 }}>
              Sommaire
            </div>
            {allBlocks?.map((chapter: any, i: number) => {
              if (chapter?.bloc_template === 2) {
                return (
                  <div
                    key={(chapter.id || chapter.title) ?? index}
                    className={
                      chapter.title_type === 'subtitle'
                        ? classes.subtitleSommaire
                        : classes.titleSommaire
                    }>
                    {chapter.title}
                  </div>
                );
              }
            })}
          </div>
        );
      case 7:
        return (
          <div className={classes.blockVideo} style={{ position: 'relative' }}>
            {!block?.videoBook ? (
              <CircularProgress
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#0E1247',
                }}
              />
            ) : (
              <MediaVideoPlayer videoUrl={block?.videoBook} />
            )}

            <div className={classes.iconBtnImage} key={url}>
              <IconButton
                aria-label="delete"
                style={{ background: '#E63C3C' }}
                onClick={() => {
                  queueVideoDeletion(block?.videoBook);
                  const updatedItems = [...allBlocks];
                  updatedItems.splice(index, 1);
                  setAllBlock(updatedItems);
                }}>
                <Close className={classes.icon} />
              </IconButton>
              <IconButton
                aria-label="delete"
                style={{ background: '#000A8C', marginTop: 15 }}
                onClick={() => handleSetVideoBlock(index)}>
                <Broder className={classes.icon} />
              </IconButton>
            </div>
          </div>
        );
      default:
    }
  };

  const handleSetVideoBlock = (index: number) => {
    setIndexSelectedForVideo(index);
    setVideoImportInitial({ video: allBlocks[index].videoBook || '' });
    setOpenDialogVideo(true);
    setIsEditedVideo(true);
  };

  const handleChangeInput = (value: any, index: number, field: string) => {
    setAllBlock((prevBlocks: any) => {
      const newItems = [...prevBlocks];
      newItems[index][field] = value;
      dispatch(ebookBookTemplateActions.updateField('content', newItems));

      return newItems;
    });
  };

  const handleChangeOption = (blockIndex: number, responseIndex: number, value: string) => {
    const newBlocks = [...allBlocks];
    if (newBlocks[blockIndex].qcm && newBlocks[blockIndex].qcm[0]?.response) {
      newBlocks[blockIndex].qcm[0].response[responseIndex].responseText = value;
    }
    setAllBlock(newBlocks);
    dispatch(ebookBookTemplateActions.updateField('content', newBlocks));
  };

  const handleAddOption = (index: number, isOther = false) => {
    const newBlocks = [...allBlocks];
    const newQCM = newBlocks[index].qcm ? [...newBlocks[index].qcm] : [];
    const newResponse = newQCM[0]?.response ? [...newQCM[0].response] : [];
    newResponse.push({ idx: newResponse.length + 1, responseText: '', score: null, isOther });
    if (newQCM.length > 0) {
      newQCM[0].response = newResponse;
    } else {
      newQCM.push({ idx: 1, question: '', type: 'radio', response: newResponse });
    }
    newBlocks[index].qcm = newQCM;
    setAllBlock(newBlocks);
    dispatch(ebookBookTemplateActions.updateField('content', newBlocks));
  };

  const handleDeleteOption = (blockIndex: number, optionIndex: number) => {
    const newBlocks = [...allBlocks];
    if (newBlocks[blockIndex].qcm && newBlocks[blockIndex].qcm[0]?.response) {
      newBlocks[blockIndex].qcm[0].response = newBlocks[blockIndex].qcm[0].response.filter(
        (response: any, i: any) => i !== optionIndex
      );
    }
    setAllBlock(newBlocks);
    dispatch(ebookBookTemplateActions.updateField('content', newBlocks));
  };

  const selectType = (bloc_template: any) => {
    if (bloc_template !== 5 && bloc_template !== 7) {
      const newType = {
        bloc_template,
        title: '',
        paragraphe: '',
        encyclopedia: null,
        free_question_title: '',
        author: '',
        title_type: bloc_template === 2 ? 'title' : '',
        img: null,
        qcm: [],
        value: '',
        numLines: 7,
        styleEditor: null,
        contentForType: 'normal',
        citation: '',
        alignement: 'flex-start',
        videoBook: '',
        imgLink: '',
        checkedLink: false,
      };
      const newBlocks: any = [...allBlocks, newType];
      const indexLast = parseInt(newBlocks?.length, 10);
      setAllBlock(newBlocks);
      // dispatch(ebookBookTemplateActions.updateField('content', newBlocks));
      setShowMenu(false);
      setIndexSelected(indexLast);
      scrollToBottom(newBlocks);
    } else if (bloc_template === 7) {
      setVideoImportInitial({ video: '' });
      setOpenDialogVideo(true);
      setIsEditedVideo(false);
    } else {
      const imgR = imgRef.current;
      if (imgR) {
        imgR.click();
      }
    }
  };

  const moveElement = (fromIndex: number, toIndex: number) => {
    const updatedItems = [...allBlocks];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    setAllBlock(updatedItems);
    dispatch(ebookBookTemplateActions.updateField('content', updatedItems));
    setIndexSelected(toIndex);
    setBlockSelected(updatedItems[toIndex]);
    setPulseMove((prev: number) => prev + 1);
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value.trim();
    if (value === '') {
      setValueInput('');
      return;
    }
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue)) {
      setValueInput(numericValue);
    }
  };

  const handleMoveToPosition = () => {
    if (allBlocks?.length > 0 && valueInput !== '' && !isNaN(valueInput)) {
      const maxPages = parseInt(allBlocks?.length || 0, 10);
      const clampedValue = valueInput >= maxPages ? maxPages : valueInput < 1 ? 1 : valueInput;
      const targetIndex = clampedValue - 1;
      moveElement(indexSelected, targetIndex);
      scrollToSection(targetIndex);
      setValueInput(clampedValue);
    }
  };

  const handleConfirm = () => {
    if (openExit) {
      setOpenExit(false);
      setOpen(false);
      ebookBookTemplateActions.resetValuesEbooks();
      sessionStorage.setItem('fromEbook', 'true');
      history.push(`/admin/game/list`);
    } else {
      handleAddUpdate(true);
      setOpen(false);
    }
  };

  const handleCancel = () => {
    // handle cancel action
    setOpen(false);
    setOpenExit(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenExit(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      const message = 'Êtes-vous sûr de vouloir quitter sans sauvegarder vos modifications ?';
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleChangeImg = (acceptedFiles: any) => {
    const uri = URL.createObjectURL(acceptedFiles[0]);
    setUrl(uri);
    setOpenEditImg(true);
    if (uri) {
      const img = new Image();
      img.src = uri;

      img.onload = () => {
        setImageDimensions({
          height: img.height,
          width: img.width,
        });
      };
      img.onerror = () => {
        console.error('Failed to load image');
      };
      setShowMenu(false);
    }
  };

  const handleChangeInputImg = (uri: any, i: any, l: string, cl: boolean) => {
    if (indexEditImg === null) {
      if (uri) {
        const newType = {
          bloc_template: 5,
          title: '',
          paragraphe: '',
          encyclopedia: null,
          free_question_title: '',
          author: '',
          title_type: '',
          img: {
            id: i,
            url: uri,
          },
          qcm: [],
          value: '',
          numLines: 7,
          styleEditor: null,
          contentForType: 'normal',
          citation: '',
          alignement: 'flex-start',
          imgLink: l,
          checkedLink: cl,
        };
        const newBlocks: any = [...allBlocks, newType];
        const indexLast = parseInt(newBlocks?.length, 10);
        setIndexSelected(indexLast);
        setAllBlock(newBlocks);
        scrollToBottom(newBlocks);
      }
    } else {
      setAllBlock((prevBlocks: any) => {
        const newItems = [...prevBlocks];
        newItems[indexEditImg].img.url = uri;
        newItems[indexEditImg].imgLink = l;
        newItems[indexEditImg].checkedLink = cl;
        dispatch(ebookBookTemplateActions.updateField('content', newItems));
        return newItems;
      });
      setIndexEditImg(null);
    }
  };

  const deleteBlock = () => {
    if (allBlocks[indexSelected]?.bloc_template === 7) {
      queueVideoDeletion(allBlocks[indexSelected]?.videoBook);
    }
    const updatedItems = [...allBlocks];
    updatedItems.splice(indexSelected, 1);
    setAllBlock(updatedItems);
    setPulseMove((prev: number) => prev + 1);
    setOpenModal(false);
  };

  const addLink = (showLink: any) => {
    if (allBlocks[indexSelected]?.bloc_template === 1) {
      setAllBlock((prevData: any) => {
        const dataPrev = [...prevData];
        dataPrev[indexSelected].showLinkPopup = showLink;
        return dataPrev;
      });
    }
  };

  useEffect(() => {
    if (pendingScrollIndex === null) return;

    if (scrollObserverRef.current) {
      scrollObserverRef.current.disconnect();
      scrollObserverRef.current = null;
    }

    // Marque qu'un scroll programmé est en cours
    isProgrammaticScrollRef.current = true;

    let attempts = 0;
    const maxAttempts = 20;

    const scrollToElement = () => {
      const titleElement = document.getElementById(`title-${pendingScrollIndex}`);
      const blockElement = document.querySelector(`[data-block-index="${pendingScrollIndex}"]`);
      const element = titleElement || blockElement;

      if (element) {
        const isVisible = element.getBoundingClientRect().height > 0;
        if (isVisible) {
          element.scrollIntoView({ behavior: 'auto', block: titleElement ? 'start' : 'end' });

          // Réactive onScroll après un court délai pour laisser le scroll se terminer
          setTimeout(() => {
            isProgrammaticScrollRef.current = false;
          }, 200);

          setIsNavigating(false);
          setPendingScrollIndex(null);
          return true;
        }
      }

      attempts++;
      if (attempts < maxAttempts) {
        requestAnimationFrame(scrollToElement);
      } else {
        // Réactive onScroll même en cas d'échec
        isProgrammaticScrollRef.current = false;
        setIsNavigating(false);
        setPendingScrollIndex(null);
      }
      return false;
    };

    requestAnimationFrame(scrollToElement);

    return () => {
      if (scrollObserverRef.current) {
        scrollObserverRef.current.disconnect();
        scrollObserverRef.current = null;
      }
    };
  }, [pendingScrollIndex]);

  const scrollToSection = (index: number) => {
    // Désactive onScroll pendant le scroll programmé
    isProgrammaticScrollRef.current = true;

    setIsNavigating(true);
    setIndexSelected(index);
    setValueInput(index + 1);
    if (allBlocks[index]) setBlockSelected(allBlocks[index]);

    const total = allBlocks?.length || 0;
    const windowStart = Math.max(0, Math.min(index - WINDOW_MARGIN, total - WINDOW_SIZE));
    setRenderStart(windowStart);

    // Déclenche le scroll précis vers l'élément une fois rendu
    // On attend un peu pour que React ait le temps de rendre avec la nouvelle fenêtre virtuelle
    setTimeout(() => {
      setPendingScrollIndex(index);
    }, 100);
  };

  const handleVideoImportSubmit = (value: VideoImportValue) => {
    const videoUrl = value.video;
    if (!isEditedVideo) {
      const newType = {
        bloc_template: 7,
        title: '',
        paragraphe: '',
        encyclopedia: null,
        free_question_title: '',
        author: '',
        title_type: '',
        img: null,
        qcm: [],
        value: '',
        numLines: 7,
        styleEditor: null,
        contentForType: 'normal',
        citation: '',
        alignement: 'flex-start',
        videoBook: videoUrl,
        imgLink: '',
        checkedLink: false,
      };
      const newBlocks: any = [...allBlocks, newType];
      const indexLast = parseInt(newBlocks?.length, 10);
      setAllBlock(newBlocks);
      setIndexSelected(indexLast);
      setShowMenu(false);
      scrollToBottom(newBlocks);
    } else {
      const blockIndex = indexSelectedForVideo || 0;
      const previousVideo = allBlocks[blockIndex]?.videoBook;
      if (previousVideo && previousVideo !== videoUrl) {
        queueVideoDeletion(previousVideo);
      }
      const cloneAllBlock = cloneDeep(allBlocks);
      cloneAllBlock[blockIndex].videoBook = videoUrl;
      setAllBlock([...cloneAllBlock]);
      dispatch(ebookBookTemplateActions.updateField('content', [...cloneAllBlock]));
    }
    setOpenDialogVideo(false);
    setIsEditedVideo(false);
  };

  return (
    <Layout isaddBackground={true} showOverFlow={true}>
      <>
        <Loader open={loading} text={textLoading} />
        <ModalEditGame
          open={open || openExit}
          handleClose={handleClose}
          title={valuesEbooksTemplate?.title}
          message={
            open
              ? `Vous êtes sur le point de publier l'ebook`
              : `Êtes-vous sûr de vouloir quitter l'édition du book ?`
          }
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        />
        <Grid container={true}>
          <Grid item={true} sm={2} className={classes.section1}>
            <div className={classes.inner}>
              <div
                className={`${classes.wrapbutton}`}
                // onMouseEnter={() => handleMouseEnter(0)}
                // onMouseLeave={() => handleMouseLeave(0)}
              >
                <IconButton
                  aria-label="delete"
                  className={classes.iconButton}
                  onClick={() => {
                    setOpenExit(true);
                  }}>
                  <Move className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Quitter sans sauvegarder</div>
              </div>
              <div
                className={`${classes.wrapbutton}`}
                // onMouseEnter={() => handleMouseEnter(1)}
                // onMouseLeave={() => handleMouseLeave(1)}
              >
                <IconButton
                  aria-label="save"
                  className={classes.iconButton}
                  onClick={() => {
                    handleAddUpdate();
                  }}>
                  <Save className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Sauvegarder comme brouillon</div>
              </div>
              <div
                className={`${classes.wrapbutton}`}
                //  onMouseEnter={() => handleMouseEnter(2)}
                // onMouseLeave={() => handleMouseLeave(2)}
              >
                <IconButton
                  aria-label="delete"
                  className={classes.iconButton}
                  onClick={() => {
                    setOpen(true);
                  }}>
                  <Browser className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Publier</div>
              </div>
            </div>
          </Grid>
          <Grid item={true} sm={10} className={classes.section2}>
            <div style={{ padding: '10px 30px', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Grid container={true}>
                  <Grid item={true} sm="auto" className={classes.containerGrid}>
                    <div className={classes.containerPageNumber}>
                      <Typography variant="h4" className={classes.title2}>
                        Position du bloc
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={classes.formInputNumber}
                        name="test-name"
                        type="text"
                        inputProps={{
                          min: 1,
                          max: parseInt(((allBlocks?.length - 1) as any) || 0, 10),
                        }}
                        value={valueInput}
                        onChange={handleInputChange}
                        onKeyDown={(e: any) => {
                          if (e.key === 'Enter') {
                            handleMoveToPosition();
                          }
                        }}
                      />
                      <div className={classes.containerIconS}>
                        <KeyboardArrowUp
                          onClick={() => {
                            if (indexSelected > 0 && allBlocks?.length > 0) {
                              const newIndex = indexSelected - 1;
                              moveElement(indexSelected, newIndex);
                              scrollToSection(newIndex);
                            }
                          }}
                          className={classes.iconS}
                        />
                        <KeyboardArrowDown
                          onClick={() => {
                            if (
                              indexSelected < parseInt(((allBlocks?.length - 1) as any) || 0, 10) &&
                              allBlocks?.length > 0
                            ) {
                              const newIndex = indexSelected + 1;
                              moveElement(indexSelected, newIndex);
                              scrollToSection(newIndex);
                            }
                          }}
                          className={classes.iconS}
                        />
                      </div>
                      <Button
                        size="small"
                        variant="contained"
                        disabled={valueInput === '' || valueInput === indexSelected + 1}
                        style={{
                          minWidth: 36,
                          padding: '4px 8px',
                          marginLeft: 8,
                          background:
                            valueInput === '' || valueInput === indexSelected + 1
                              ? '#ccc'
                              : '#000A8C',
                          color: '#fff',
                          fontSize: 11,
                        }}
                        onClick={handleMoveToPosition}>
                        OK
                      </Button>
                    </div>
                  </Grid>
                  <Grid item={true} sm="auto" className={classes.containerGrid}>
                    <Button
                      color="primary"
                      style={{ marginLeft: 0 }}
                      startIcon={<Delete className={classes.iconbig} />}
                      onClick={() => setOpenModal(true)}>
                      <Typography variant="h4" className={classes.title2}>
                        Supprimer le bloc
                      </Typography>
                    </Button>
                    <SimpleModal
                      open={openModal}
                      handleClose={() => setOpenModal(false)}
                      title="Information"
                      message="Êtes vous sur de vouloir supprimer le bloc ?"
                      textClick="Oui"
                      textClose="Non"
                      handleClick={deleteBlock}
                    />
                  </Grid>
                  {allBlocks &&
                    allBlocks?.length > 0 &&
                    allBlocks[indexSelected]?.bloc_template === 2 && (
                      <Grid
                        item={true}
                        sm="auto"
                        className={classes.containerGrid}
                        style={{ borderLeft: '1px solid #7C7C7C' }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginLeft: 10,
                            marginRight: 10,
                            padding: '5px 7.5px',
                            background: '#ECECEC',
                          }}>
                          <span style={{ fontSize: 11 }}>Type de titre</span>
                          <select
                            className={classes.selectLine}
                            style={{ margin: 0 }}
                            value={blockSelected?.title_type}
                            onChange={e =>
                              handleChangeInput(e.target.value, indexSelected, 'title_type')
                            }>
                            <option value="title">Titre</option>
                            <option value="subtitle">Sous titre</option>
                          </select>
                        </div>
                      </Grid>
                    )}
                  {allBlocks &&
                    allBlocks.length > 0 &&
                    allBlocks[indexSelected]?.bloc_template === 1 && (
                      <Grid
                        item={true}
                        sm="auto"
                        className={classes.containerGrid}
                        style={{ borderLeft: '1px solid #7C7C7C' }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginLeft: 10,
                            marginRight: 10,
                            padding: '5px 7.5px',
                            background: '#ECECEC',
                          }}>
                          <span style={{ fontSize: 11 }}>Type de texte</span>
                          <select
                            className={classes.selectLine}
                            style={{ margin: 0 }}
                            value={blockSelected?.contentForType}
                            onChange={e =>
                              handleChangeInput(e.target.value, indexSelected, 'contentForType')
                            }>
                            <option value="normal">Normal</option>
                            <option value="citation">Citation</option>
                            <option value="encyclopedia">Encyclopedie</option>
                          </select>
                        </div>
                      </Grid>
                    )}
                  {allBlocks &&
                    allBlocks?.length > 0 &&
                    allBlocks[indexSelected]?.bloc_template === 1 &&
                    allBlocks[indexSelected]?.contentForType !== 'citation' && (
                      <Grid item={true} sm={12} style={{ marginLeft: '-12px', marginTop: 3 }}>
                        <BarEdition
                          stateEdition={stateEdition}
                          editState={editStyleEditor}
                          handleLink={addLink}
                          isEbook={false}
                          editPosition={editPosition}
                          position={position}
                        />
                      </Grid>
                    )}
                </Grid>
                <div style={{ position: 'relative' }}>
                  <Button
                    size="small"
                    color="primary"
                    disableRipple={true}
                    className={classes.btnAddBlock}
                    style={{ background: '#000A8C' }}
                    onClick={() => setShowMenu(!showMenu)}
                    endIcon={<Add className={classes.btnicon} />}>
                    Ajouter un bloc
                  </Button>
                  {showMenu && (
                    <div className={classes.menuContainer}>
                      <div style={{ width: '100%', position: 'relative', height: 15 }}>
                        <div className={classes.polygoneTriangle} />
                      </div>
                      <div className={classes.menu}>
                        <h3 className={classes.titleBlock}>
                          Sélectionnez le type de bloc que vous souhaitez ajouter{' '}
                        </h3>
                        <Grid container={true} spacing={2}>
                          <input
                            type="file"
                            accept="image/*"
                            ref={imgRef}
                            style={{ display: 'none' }}
                            onChange={e => handleChangeImg(e.target.files)}
                          />
                          {templateBlocks?.map((block: any, index: number) => (
                            <Grid key={block.id ?? index} item={true} sm={6}>
                              <div
                                className={classes.containerBlock}
                                onClick={() => selectType(block.id)}>
                                <img
                                  src={block?.attributes?.img?.data?.attributes?.url}
                                  alt={block?.attributes?.name}
                                  className={classes.imgBlock}
                                  loading="lazy"
                                  style={{ height: 49 }}
                                />
                                <h3 className={classes.titleItem}>{block?.attributes?.name}</h3>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                      </div>
                    </div>
                  )}
                  <ModalEditingEbook
                    open={openEditImg}
                    fileUrl={url}
                    handleClose={() => {
                      setOpenEditImg(false);
                      setDataImg({
                        imgLink: '',
                        checkedLink: false,
                      });
                      setIndexEditImg(null);
                    }}
                    handleUrl={(u: any, i: any, l: string, cl: boolean) =>
                      handleChangeInputImg(u, i, l, cl)
                    }
                    imgHeightB={imageDimensions.height as any}
                    imgWidthB={imageDimensions.width}
                    imgLink={dataImg.imgLink}
                    checkedLink={dataImg.checkedLink}
                  />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container={true} style={{ background: '#F1F1F1' }}>
          {/* Debut Sommaire contextuel */}
          <Grid
            item={true}
            sm={2}
            className={classes.section3}
            onClick={() => setShowEdition(false)}>
            <ItemPage
              id="1"
              title={valuesEbooksTemplate?.title || 'titre du ebook'}
              url={
                valuesEbooksTemplate?.img?.url ||
                'https://storage.googleapis.com/orient-action.appspot.com/xx_85ae6992d2.png?updated_at=2024-05-27T18:25:35.428Z'
              }
              isCover={true}
              handleClick={() => history.push('/admin/ebook/edit-main/')}
            />
            <div style={{ height: '65vh', overflowY: 'auto' }}>
              {allBlocks &&
                allBlocks?.length > 0 &&
                allBlocks?.map((chapter: any, index: number) => {
                  if (chapter?.bloc_template === 2) {
                    return (
                      <ItemChapter
                        key={index}
                        id={index as any}
                        title={chapter.title}
                        isSubChapter={chapter.title_type === 'subtitle'}
                        isSelected={index === currentTitleIndex}
                        handleClick={() => {
                          setIndexSelected(index);
                          setBlockSelected(chapter);
                          setValueInput(index + 1);
                          setCurrentTitleIndex(index);
                          scrollToSection(index);
                        }}
                      />
                    );
                  }
                })}
            </div>
          </Grid>{' '}
          {/* Fin Sommaire contextuel */}
          <Grid ref={containerRef} item={true} sm={10} className={classes.section4}>
            <div className={classes.ebookContainer}>
              {isNavigating && (
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2,
                    pointerEvents: 'none',
                    fontSize: 12,
                    color: '#555',
                  }}>
                  <div style={{ textAlign: 'center' }}>
                    <div>Chargement…</div>
                    {allBlocks && allBlocks.length > 100 && (
                      <div style={{ fontStyle: 'italic', marginTop: 4 }}>
                        Le chargement peut prendre quelques secondes
                      </div>
                    )}
                  </div>
                </div>
              )}
              {loadingTop && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                  }}>
                  <CircularProgress size={30} />
                </div>
              )}
              {renderStart === 0 && (
                <img
                  className={classes.imgCover}
                  src={
                    valuesEbooksTemplate?.img?.url ||
                    'https://storage.googleapis.com/orient-action.appspot.com/xx_85ae6992d2.png?updated_at=2024-05-27T18:25:35.428Z'
                  }
                  loading="lazy"
                  alt=""
                />
              )}
              {allBlocks &&
                allBlocks?.length > 0 &&
                allBlocks
                  ?.slice(renderStart, Math.min(renderStart + WINDOW_SIZE, allBlocks.length))
                  .map((block: any, localIndex: number) => {
                    const absoluteIndex = renderStart + localIndex;
                    return (
                      <div key={absoluteIndex} data-block-index={absoluteIndex}>
                        <ItemBlocks
                          key={absoluteIndex}
                          number={absoluteIndex + 1}
                          isSelected={absoluteIndex === indexSelected}
                          handleClick={() => {
                            setIndexSelected(absoluteIndex);
                            setBlockSelected(block);
                            setValueInput(absoluteIndex + 1);
                          }}>
                          {renderTypeBlock(block, absoluteIndex)}
                        </ItemBlocks>
                      </div>
                    );
                  })}
              {loadingBottom && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                  }}>
                  <CircularProgress size={30} />
                </div>
              )}
            </div>
          </Grid>
        </Grid>
        <VideoImport
          open={openDialogVideo}
          onClose={() => setOpenDialogVideo(false)}
          onSubmit={handleVideoImportSubmit}
          initialValue={videoImportInitial}
          youtubeInputId="ebook-video-youtube-url"
        />
      </>
    </Layout>
  );
};

export default EditEbookPage;
